//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

export enum ProductFeedHealthStatusType {
  NOT_ACQUIRED = 'not_acquired',
  PENDING = 'pending',
  HEALTHY = 'healthy',
  NEEDS_ATTENTION = 'needs_attention',
  FAILURE_BAD_ACQUIRE = 'failure_bad_acquire',
  FAILURE_BAD_FORMATTING = 'failure_bad_formatting',
  FAILURE_LARGE_LOSS = 'failure_large_loss',
  FAILURE_STALE_CATALOG = 'failure_stale_catalog',
}

export enum ProductFeedProtocolType {
  API = 'api',
  FTP = 'ftp',
  SFTP = 'sftp',
  HTTP = 'http',
  HTTPS = 'https',
  S3_SFTP = 's3_sftp',
  S3_STATIC = 's3_static',
  S3_DEPRECATED = 's3_deprecated',
  S3_BAZAAR_VOICE = 's3_bazaar_voice',
  SHOPIFY = 'shopify',
  SHOPIFY2 = 'shopify2',
  MAGENTO = 'magento',
  SYNTHETIC_FEEDS = 'synthetic-feeds',
}

export const PRODUCT_FEED_HEALTH_SUPPORT_EMAIL = 'support@curalate.com';
